window.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".barchart").forEach((el) => {
    el.classList.add("hide");
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle("hide", !entry.isIntersecting);
      });
    });
    observer.observe(el);
  });
});
